import { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { listCities } from '../../../../../../insfrastructure/services/cities';
import { StaticValues } from '../../../../../../insfrastructure/services/static_values';
import { createCandidate } from '../../../../../../insfrastructure/services/candidates';
import { retrievePostcodeInfo } from '../../../../../../insfrastructure/services/cep';
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component';
import { ErrorMessage, emptyField, errorsLength, formatErrors, validateCEP, validatePasswordConfirmation } from '../../../../../../insfrastructure/utils/form-validators';
import { omitEmpty } from '../../../../../../insfrastructure/utils/object-utils';
import { Input } from '../../../../../components/input';
import { Select } from '../../../../../components/select';
import RadioInput from '../../../../../components/radio';
import CheckboxInput from '../../../../../components/checkbox';
import { SubmitBtn } from '../../../../../components/submit';
import ResponseModal from '../../../../../components/response-modal';
import { PasswordRequirements } from '../../../../../components/password-requirements';
import candidateImg from '../../../../../../assets/images/candidate.png';
import './styles.sass';

class CandidateForm extends Component<RouterProps> {
  state: any = {
    form: {
      "full_name": "",
      "cpf": "",
      "email": "",
      "mobile": "",
      "date_of_birth": "",
      "password": "",
      "gender": "",
      "marital_status": "",
      "salary_expectation": '0',
      "city_id": 0,
      "postcode": "",
      "address": "",
      "address_number": "",
      "address_district": "",
      "address_complement": "",
      "city_uf": "",
      "escola_do_mecanico_id": null,
      "terms_and_conditions": false
    },
    formErrors: {},
    loading: false,
    loadingCityOptions: false,
    cityOptions: [],
    em_units: [],
    cities: [],
    genderOptions: [],
    maritalStatusOptions: []
  }
  citiesSearchTimeout: any = null

  componentDidMount() {
    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
  
      const em_units = Object.values(staticValues.em_unit).map((x: any) => ({ value: x.branch_number, label: x.name }));
      const genderOptions = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
      const maritalStatusOptions = Object.keys(staticValues.marital_status).map((key: any) => ({ value: key, label: staticValues.marital_status[key] }));
  
      this.setState({ em_units, genderOptions, maritalStatusOptions });
    } catch (error) {}
  }

  onCityNameSearch = async (e: any, no_timeout?: boolean) => {
    clearTimeout(this.citiesSearchTimeout);

    if (e.length < 3) {
      return;
    };

    this.setState({ loadingCityOptions: true }, async () => {
      this.citiesSearchTimeout = setTimeout(async () => {
        const cities = (await listCities(e));
        const cityOptions = cities.map(x => ({ value: parseInt(x.id+''), label: x.displayName }));

        this.setState({ cities, cityOptions, loadingCityOptions: false });
      }, no_timeout ? 0 : 1000);
    });
  }

  timeout: any = null

  onCEPChange = async (value: any) => {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(async () => {
      let result: any = null;

      if(validateCEP(value) === '') {
        try {
          result = await retrievePostcodeInfo(value);
        } catch (error) {
          this.setState({
            responseData: {
              type: 'error',
              title: 'CEP Inválido',
              text: ''
            }
          });

          return;
        };

        await this.onCityNameSearch(result.localidade, true);

        setTimeout(() => {
          this.onSelectCity(result.city_id); 
        }, 1000);

        // Preencher campos de endereço automaticamente
        this.setState({
          form: {
            ...this.state.form,
            address: result.logradouro || '',
            address_district: result.bairro || '',
            city_uf: result.uf || ''
          }
        });
      };
    }, 1000);
  }

  onSelectCity = async (city_id: any) => {
    const city = this.state.cities.filter((x: any) => x.id === city_id+'')[0];

    this.setState({
      form: {
        ...this.state.form,
        city_id,
        city_uf: city ? city.uf : ''
      }
    });
  }

  onSubmit = async () => {
    if (this.state.loading) return;

    const form = omitEmpty({
      ...this.state.form,
      cpf: this.state.form.cpf.replace(/[.-]/g,""),
      date_of_birth: moment(this.state.form.date_of_birth).format('YYYY-MM-DD'),
      skills: []
    });

    let errorsValidations: any = {
      full_name: [emptyField(form.full_name, 'string')], 
      // full_name: [emptyField(form.full_name, 'string'), validateRegex(this.state.form.full_name, /^[A-Za-z0-9@/./+/-/\-_]+$/, 'Nome do usuário inválido')], 
      cpf: [emptyField(form.cpf, 'string')], 
      email: [emptyField(form.email, 'string')], 
      mobile: [emptyField(form.mobile, 'string')], 
      date_of_birth: [emptyField(form.date_of_birth, 'string')], 
      password: [emptyField(form.password, 'string')], 
      password_confirmation: [emptyField(form.full_name, 'string'), validatePasswordConfirmation(form.password, form.password_confirmation)], 
      gender: [emptyField(form.gender, 'string')], 
      marital_status: [emptyField(form.marital_status, 'string')], 
      salary_expectation: [emptyField(form.salary_expectation, 'number')], 
      postcode: [emptyField(form.postcode, 'string')],
      address_number: [emptyField(form.address_number, 'string')],
      city_id: [emptyField(form.city_id, 'number')],
      terms_and_conditions: [emptyField(form.terms_and_conditions)]
    };

    if (this.state.form.is_studant === 'yes') {
      errorsValidations['escola_do_mecanico_id'] = [emptyField(form.escola_do_mecanico_id, 'number')];
    } else {
      delete form.escola_do_mecanico_id;
    };

    const errors = formatErrors(errorsValidations);

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

    try {
      this.setState({ loading: true });

      await createCandidate(form as any);

      setTimeout(() => {  
        this.setState({ loading: false });
        this.props.navigate('/sign-up/candidate/confirmation/request', { state: { email: form.email } });
      });
    } catch (error: any) {
      let errors: string[] = [];

      if (error.response.data['email']) {
        errors.push('Email já cadastrado');
      };
      
      if (error.response.data['full_name']) {
        errors.push('Nome já cadastrado');
      };

      let responseData = {
        type: 'error',
        title: 'Erro ao cadastrar',
        text: () => <>
          { errors.map(error => <p>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    };
  }

  render() {
    return (
      <div className='candidate-sign-up-form'>
        <h3>Dados Candidato</h3>
        <div className='columns'>
          <div className='column'>
          <Input
            name='full_name'
            label='Nome completo'
            value={this.state.form['full_name']}
            onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}/>
            <ErrorMessage errors={this.state.formErrors['full_name']} />
            <Input
            name='email'
            label='Email'
            value={this.state.form['email']}
            onChange={e => this.setState({ form: { ...this.state.form, email: e } })}/>
            <ErrorMessage errors={this.state.formErrors['email']} />
            <Input
            name='date_of_birth'
            label='Data Nascimento'
            type='date'
            mask='99/99/9999'
            placeholder='DD/MM/AAAA'
            value={this.state.form['date_of_birth']}
            onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}/>
            <ErrorMessage errors={this.state.formErrors['date_of_birth']} />
            <Select
            name='marital_status'
            label='Estado Civil'
            value={this.state.form['marital_status']}
            options={this.state.maritalStatusOptions}
            onChange={e => this.setState({ form: { ...this.state.form, marital_status: e } })}/>
            <ErrorMessage errors={this.state.formErrors['marital_status']} />
            <Input
            name='postcode'
            label='CEP'
            mask='99999-999'
            value={this.state.form.postcode}
            onChange={e => {this.setState({ form: { ...this.state.form, postcode: e } }); this.onCEPChange(e)}} />
            <ErrorMessage errors={this.state.formErrors['postcode']} />
            <Input
            name='address'
            label='Endereço'
            value={this.state.form.address}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address']} />
            <Input
            name='address_number'
            label='Número'
            value={this.state.form.address_number}
            onChange={e => this.setState({ form: { ...this.state.form, address_number: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_number']} />
            <Input
            name='password'
            label='Senha'
            type='password'
            value={this.state.form.password}
            onChange={e => this.setState({ form: { ...this.state.form, password: e } })}/>
            <ErrorMessage errors={this.state.formErrors['password']} />
            <PasswordRequirements
            password={this.state.form.password}
            email={this.state.form.email}
            isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}/>
            <div className='terms-and-conditions-container'>
              <CheckboxInput
              name='terms_and_conditions'
              label={
                () => (
                  <div>
                    Aceito a{' '}
                    <a 
                      href='https://staging.empregamecanico.com.br/privacy-policy' 
                      target='_blank' 
                      rel='noopener noreferrer'
                      style={{ color: '#FFD700', textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Política de Privacidade
                    </a>
                  </div>
                )
              }
              checked={this.state.form.terms_and_conditions}
              onChange={e => this.setState({ form: { ...this.state.form, terms_and_conditions: e } })}/>
              <ErrorMessage errors={this.state.formErrors['terms_and_conditions']} />
            </div>
          </div>
          <div className='column'>
            <Input
            name='cpf'
            label='CPF'
            value={this.state.form['cpf']}
            onChange={e => this.setState({ form: { ...this.state.form, cpf: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cpf']} />
            <Input
            name='mobile'
            label='Celular'
            mask='(99) 99999-9999'
            value={this.state.form['mobile']}
            onChange={e => this.setState({ form: { ...this.state.form, mobile: e } })}/>
            <ErrorMessage errors={this.state.formErrors['mobile']} />
            <Select
            name='gender'
            label='Gênero'
            value={this.state.form['gender']}
            options={this.state.genderOptions}
            onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}/>
            <ErrorMessage errors={this.state.formErrors['gender']} />
            <Input
            name='salary_expectation'
            label='Pretensão Salarial'
            type='money'
            value={this.state.form['salary_expectation']}
            onChange={e => this.setState({ form: { ...this.state.form, salary_expectation: e } })}/>
            <ErrorMessage errors={this.state.formErrors['salary_expectation']} />
            <Select
            name='city_id'
            label='Cidade'
            options={this.state.cityOptions}
            value={this.state.form.city_id}
            hasSearch={true}
            onSearchChange={e => this.onCityNameSearch(e)}
            loading={this.state.loadingCityOptions}
            onChange={e => {this.setState({ form: { ...this.state.form, city_id: e } }); this.onSelectCity(e);}}/>
            <ErrorMessage errors={this.state.formErrors['city_id']} />
            <Input
            name='address_district'
            label='Bairro'
            value={this.state.form.address_district}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address_district: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_district']} />
            <Input
            name='city_uf'
            label='Estado'
            value={this.state.form.city_uf}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, city_uf: e } })}/>
            <ErrorMessage errors={this.state.formErrors['city_uf']} />
            <Input
            name='password_confirmation'
            label='Confirmar Senha'
            type='password'
            onChange={e => this.setState({ form: { ...this.state.form, password_confirmation: e } })}/>
            <ErrorMessage errors={this.state.formErrors['password_confirmation']} />
          </div>
          <div className='column'>
            <img src={candidateImg} alt='candidate' />
            <RadioInput
            name='is_studant'
            label='Aluno da Escola do Mecânico?'
            options={[
              {
                label: 'Sim',
                value: 'yes'
              },
              {
                label: 'Não',
                value: 'no'
              }
            ]}
            onChange={e => this.setState({ form: { ...this.state.form, is_studant: e, escola_do_mecanico_id: 0 } })}/>
            {this.state.form.is_studant === 'yes' &&
            <>
              <Select
              name='escola_do_mecanico_id'
              label='Unidade da Escola do Mecânico'
              placeholder='Unidade da Escola do Mecânico'
              value={this.state.form['escola_do_mecanico_id']}
              options={this.state.em_units}
              onChange={e => this.setState({ form: { ...this.state.form, escola_do_mecanico_id: e } })}/>
              <ErrorMessage errors={this.state.formErrors['escola_do_mecanico_id']} />
            </>}
          </div>
        </div>
        <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
      </div>
    )
  }
}

export const CandidateFormWithRouter = withRouter(CandidateForm);